export default __webpack_public_path__ + "static/media/icon-close.c9df1bba.svg";